/**
 * Internal depedencies
 */
import { getRawLayouts } from 'state/dashboard-layouts/selectors';
import { switchLayout } from 'state/dashboard/actions';
import { getPreference } from 'state/preferences/selectors';

export default () => (dispatch, getState) => {
	const state = getState();
	const layouts = getRawLayouts(getState());
	const defaultDashboardId = getPreference(state, 'defaultDashboard');

	if (defaultDashboardId && layouts[defaultDashboardId]) {
		return dispatch(switchLayout(defaultDashboardId));
	}

	// set the first layout as active if there is no default layout;
	let k = Object.keys(layouts)[0];
	k && dispatch(switchLayout(k));
	
};
